import Axios, { AxiosError, AxiosResponse } from "axios";
import { ReportListingReq } from "../types/Report";
import api from "../axios";


export const reportProperty = (req: ReportListingReq, token: string) => {
  console.log("Request Payload:", req); // Log the request payload
  const willReportListing = new Promise<any>((resolve) => {
    api.post("/api/Reports/ReportProperty", req, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response: AxiosResponse<any>) => {
        resolve({ data: response.data });
      })
      .catch((err: AxiosError | any) => {
        resolve({ error: err });
      });
  });
  return willReportListing;
};
